export const FAJR = 'fajr';
export const DHUHR = 'dhuhr';
export const ASR = 'asr';
export const MAGHRIB = 'maghrib';
export const ISHA = 'isha';
export const ALL = 'all';
